import React from "react";

import { Maintenance } from "@Core/components/Layouts";

const MaintenancePage = () => {
  return <Maintenance />;
};

export default MaintenancePage;
